<template>
  <div>
    <button
      class="btn btn-info mb-2"
      @click.prevent="openItemModal"
      v-if="hoso_create"
    >
      <i class="fas fa-plus"></i>
      Add
      <!-- Thêm -->
    </button>
    <b-table
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(status)="data">
        <b-badge variant="success" v-if="data.value == 1">
          Active
          <!-- Đang kích hoạt -->
        </b-badge>
        <b-badge variant="secondary" v-else>
          Inactive
          <!-- Không kích hoạt -->
        </b-badge>
      </template>
      <template v-slot:cell(vitricongviec)="data">{{
        findFirst(vitricongviecs, data.value)
      }}</template>
      <!-- Delete Hinhthuclamviec column -->
      <!-- <template v-slot:cell(hinhthuclamviec)="data">{{findFirst(hinhthuclamviecs, data.value)}}</template> -->
      <template v-slot:cell(loaihopdong)="data">{{
        findFirst(loaihopdongs, data.value)
      }}</template>
      <template v-slot:cell(ngayhieuluc)="data">{{
        data.item.ngayhieuluc | moment("DD/MM/YYYY")
      }}</template>
      <template v-slot:cell(ngayhethan)="data">{{
        data.item.ngayhethan | moment("DD/MM/YYYY")
      }}</template>
      <template v-slot:cell(donvicongtac)="data">
        <!-- <treeselect
          v-model="data.item.donvicongtac"
          :options="departments"
          :normalizer="normalizer"
          disabled
        />-->
        {{ findFirstDepartment(departments, data.value) }}
      </template>
      <template v-slot:cell(phongbancongtac)="data">
        {{ findFirstDepartmentByCode(department_all, data.value) }}
      </template>
      <!-- <template v-slot:cell(sohopdong)="data" v-if="hoso_update">
        <b-link href="#" @click.prevent="openUpdateItemModal(data)">{{data.value}}</b-link>
      </template> -->
      <template v-slot:cell(action)="data">
        <b-link
          v-if="hoso_update || hoso_read"
          class="text-primary mr-2"
          href="#"
          @click="openUpdateItemModal(data)"
        >
          <i class="fas fa-pencil-alt"></i>
        </b-link>
        <!-- <button class="btn btn-info mr-2" @click="openUpdateItemModal(data)">
          <i class="fas fa-eye"></i>
        </button>
        <button class="btn btn-danger" @click="deleteItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button> -->
        <b-link
          v-if="hoso_update"
          class="text-danger"
          href="#"
          @click.prevent="deleteItem(data)"
        >
          <i class="fas fa-trash"></i>
        </b-link>
      </template>
    </b-table>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      hide-footer
      @hidden="closeItemModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <template v-slot:modal-title>
        <div v-if="item_selected.id <= 0">
          Add labor contract
          <!-- Thêm thông tin hợp đồng lao động -->
        </div>
        <div v-else>
          Update labor contract
          <!-- Cập nhật thông tin hợp đồng lao động -->
        </div>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">
        <b-tabs content-class="mt-3">
          <!-- <b-tab title="Thông tin chung" active> -->
          <b-tab title="General information" active>
            <b-form-row class="mb-4">
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    <!-- Số hợp đồng -->
                    Contract No.
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="item_selected.sohopdong"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group>
                  <!-- <b-form-checkbox
                    switch
                    v-model="item_selected.unemploymentInsurance"
                    style="width: 50%; display: inline-table;"
                  >
                  
                    Unemployment Insurance
                  </b-form-checkbox> -->
                  <b-form-checkbox
                    switch
                    v-model="item_selected.nonResident"
                    style="width: 50%; display: inline-table;"
                  >
                    <!-- Cá nhân không cư trú -->
                    Non-Resident
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row class="mb-4">
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Company
                    <!-- Đơn vị công tác -->
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    v-model="item_selected.donvicongtac"
                    :options="departments"
                    value-field="id"
                    text-field="tendonvi"
                    @change="unlockPhongban"
                  >
                    <template v-slot:first>
                      <b-form-select-option
                        :value="null"
                      ></b-form-select-option>
                    </template>
                  </b-form-select>
                  <!-- <treeselect
                  v-model="item_selected.donvicongtac"
                  :options="departments"
                  placeholder
                  :defaultExpandLevel="99999"
                  :normalizer="normalizer"
                />-->
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Department
                    <!-- Phòng ban công tác -->
                  </template>
                  <b-form-select
                    v-model="item_selected.phongbancongtac"
                    :options="department_children"
                    value-field="id"
                    text-field="tendonvi"
                    :disabled="!phongbancongtacEnabled"
                  >
                    <template v-slot:first>
                      <b-form-select-option
                        :value="null"
                      ></b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row class="mb-4">
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Position
                    <!-- Vị trí công việc -->
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    v-model="item_selected.vitricongviec"
                    :options="vitricongviecs"
                    style="width: calc(100% - 42px);"
                    value-field="id"
                    text-field="pickListValue"
                  >
                    <template v-slot:first>
                      <b-form-select-option
                        :value="null"
                      ></b-form-select-option>
                    </template>
                  </b-form-select>
                  <button
                    class="btn"
                    @click.prevent="openModal('vitricongviec')"
                  >
                    <i class="fas fa-table"></i>
                  </button>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Payment Method
                    <!-- Hình thức nhận lương -->
                  </template>
                  <b-form-select
                    v-model="item_selected.hinhthucnhanluong"
                    :options="hinhthucnhanluongs"
                    value-field="id"
                    text-field="pickListValue"
                  >
                    <template v-slot:first>
                      <b-form-select-option
                        :value="null"
                      ></b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row class="mb-4">
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Employement Type
                    <!-- Hình thức làm việc -->
                  </template>
                  <b-form-select
                    v-model="item_selected.hinhthuclamviec"
                    :options="hinhthuclamviecs"
                    value-field="id"
                    text-field="pickListValue"
                    @change="changeEmpType"
                  >
                    <template v-slot:first>
                      <b-form-select-option
                        :value="null"
                      ></b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Type
                    <!-- Loại hợp đồng -->
                  </template>
                  <b-form-select
                    :disabled="disabledCommitment"
                    v-model="item_selected.loaihopdong"
                    :options="tempContractType"
                    value-field="id"
                    text-field="pickListValue"
                  >
                    <template v-slot:first>
                      <b-form-select-option
                        :value="null"
                      ></b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row class="mb-4">
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label> Social Insurance </template>
                  <b-row>
                    <b-col>
                      <b-form-select
                        v-model="item_selected.unemploymentInsurance"
                        placeholder="Please write down the brand name"
                        class=" pt-0 pb-0"
                        size="md"
                        oninvalid="this.setCustomValidity('Please enter Status')"
                        oninput="setCustomValidity('')"
                        required
                      >
                        <b-form-select-option :value="true"
                          >VietNam</b-form-select-option
                        >
                        <b-form-select-option :value="false"
                          >Expat</b-form-select-option
                        >
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-checkbox
                  v-if="checkCommitment"
                  switch
                  v-model="item_selected.commitment"
                  style="width: 50%; display: inline-table;"
                >
                  <!-- Cá nhân không cư trú -->
                  Commitment
                </b-form-checkbox>
              </b-col>
            </b-form-row>
            <b-form-row class="mb-4">
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Valid date
                    <!-- Ngày hiệu lực -->
                    <span class="text-danger">*</span>
                  </template>
                  <vue-datepicker-local
                    style="width: 100%"
                    v-model="item_selected.ngayhieuluc"
                    :local="local"
                    clearable
                    format="DD/MM/YYYY"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Expiry Date
                    <!-- Ngày hết hạn -->
                  </template>
                  <vue-datepicker-local
                    style="width: 100%"
                    v-model="item_selected.ngayhethan"
                    :local="local"
                    clearable
                    format="DD/MM/YYYY"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
            <!-- <b-form-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">Lương cơ bản</label>
              </b-col>
              <b-col cols="3">
                <my-currency-input v-model="item_selected.luongcoban" />
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="2">
                <label class="mr-2">Lương đóng bảo hiểm</label>
              </b-col>
              <b-col cols="3">
                <my-currency-input v-model="item_selected.luongdongbh" />
              </b-col>
            </b-form-row> -->

            <!-- <b-form-row class="mb-4">
              <b-col cols="2">
                <label class="mr-2">Ghi chú</label>
              </b-col>
              <b-col cols="9">
                <b-form-textarea v-model="item_selected.ghichu" rows="2"></b-form-textarea>
              </b-col>
            </b-form-row>-->
          </b-tab>

          <b-tab v-if="hoso_hdld_read" title="Salary">
            <!-- <b-tab v-if="hoso_hdld_read" title="Lương">   -->
            <hop-dong-lao-dong-luong
              :hopdong="item_selected"
              ref="luong"
            ></hop-dong-lao-dong-luong>
          </b-tab>
          <b-tab v-else title="" disabled>
            <hop-dong-lao-dong-luong
              :hopdong="item_selected"
              ref="luong"
            ></hop-dong-lao-dong-luong>
          </b-tab>

          <b-tab v-if="hoso_hdld_read" title="Allowance">
            <!-- <b-tab v-if="hoso_hdld_read" title="Phụ cấp"> -->
            <hop-dong-lao-dong-phu-cap
              :phucaps="phucaps"
              :hopdong="item_selected"
              ref="phucap"
            ></hop-dong-lao-dong-phu-cap>
          </b-tab>
          <b-tab v-else title="" disabled>
            <hop-dong-lao-dong-phu-cap
              :phucaps="phucaps"
              :hopdong="item_selected"
              ref="phucap"
            ></hop-dong-lao-dong-phu-cap>
          </b-tab>

          <b-tab v-if="hoso_hdld_read" title="Bonus">
            <!-- <b-tab v-if="hoso_hdld_read" title="Thưởng dự án"> -->
            <hop-dong-lao-dong-thuong
              :vitricongviecs="vitricongviecs"
              :hopdong="item_selected"
              ref="thuong"
            ></hop-dong-lao-dong-thuong>
          </b-tab>
          <b-tab v-else title="" disabled>
            <hop-dong-lao-dong-thuong
              :vitricongviecs="vitricongviecs"
              :hopdong="item_selected"
              ref="thuong"
            ></hop-dong-lao-dong-thuong>
          </b-tab>

          <b-tab v-if="hoso_hdld_read" title="Sales Bonus">
            <!-- <b-tab v-if="hoso_hdld_read" title="Thưởng dự án - PM"> -->
            <hop-dong-lao-dong-thuong-truong-du-an
              :hopdong="item_selected"
              ref="thuongpm"
            ></hop-dong-lao-dong-thuong-truong-du-an>
          </b-tab>
          <b-tab v-else title="" disabled>
            <hop-dong-lao-dong-thuong-truong-du-an
              :hopdong="item_selected"
              ref="thuongpm"
            ></hop-dong-lao-dong-thuong-truong-du-an>
          </b-tab>

          <!-- <b-tab title="Phụ cấp"  >
            <hop-dong-lao-dong-phu-cap :phucaps="phucaps" :hopdong="item_selected" ref="phucap"></hop-dong-lao-dong-phu-cap>
          </b-tab>
          <b-tab title="Thưởng dự án">
              <hop-dong-lao-dong-thuong :vitricongviecs="vitricongviecs" :hopdong="item_selected" ref="thuong"></hop-dong-lao-dong-thuong>
            </b-tab> -->
          <!-- @DO NOT DELETE: Comment out because it is not needed. Might be in the future -->
          <!-- ------- -->
          <!-- <b-tab title="Hiệu quả công việc">
            <hop-dong-lao-dong-hieu-qua :hopdong="item_selected" ref="hieuqua"></hop-dong-lao-dong-hieu-qua>
          </b-tab> -->
          <!-- ------- -->
        </b-tabs>
        <b-form-row v-if="hoso_update" class="mb-3">
          <b-col cols="11" class="form-inline">
            <b-button
              class="mr-3"
              variant="dark"
              @click.prevent="stopItem"
              v-if="item_selected.status == 1"
            >
              <i class="fas fa-save mr-2"></i>
              Inactive
              <!-- Dừng kích hoạt -->
            </b-button>
            <div style="flex-grow: 1"></div>
            <b-button class="mr-3" variant="info" @click.prevent="storeItem">
              <i class="fas fa-save mr-2"></i>
              Save
              <!-- Lưu -->
            </b-button>
            <b-button variant="secondary" @click="closeItemModal">
              <i class="fas fa-times mr-2"></i>
              Close
              <!-- Đóng -->
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
// import Treeselect from "@riophae/vue-treeselect";
// import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import MyCurrencyInput from "../App/MyCurrencyInput";
import HopDongLaoDongPhuCap from "../Employee/HopDongLaoDongPhuCap";
import HopDongLaoDongHieuQua from "../Employee/HopDongLaoDongHieuQua";
import HopDongLaoDongThuong from "../Employee/HopDongLaoDongThuong";
import HopDongLaoDongThuongTruongDuAn from "../Employee/HopDongLaoDongThuongTruongDuAn";
import HopDongLaoDongLuong from "../Employee/HopDongLaoDongLuong";

export default {
  name: "HopDongLaoDong",
  props: [
    "item",
    "departments",
    "department_all",
    "hinhthucnhanluongs",
    "loaihopdongs",
    "hinhthuclamviecs",
    "vitricongviecs",
    "phucaps",
  ],
  components: {
    VueDatepickerLocal,
    //Treeselect,
    //MyCurrencyInput,
    HopDongLaoDongPhuCap,
    //HopDongLaoDongHieuQua,
    HopDongLaoDongThuong,
    HopDongLaoDongThuongTruongDuAn,
    HopDongLaoDongLuong,
  },
  data() {
    return {
      fields: [
        {
          key: "status",
          label: "Status",
          // label: "Trạng thái",
        },
        {
          key: "sohopdong",
          label: "Contract No.",
          // label: "Số hợp đồng",
        },
        {
          key: "ngayhieuluc",
          label: "Valid date",
          // label: "Ngày hiệu lực",
        },
        {
          key: "ngayhethan",
          label: "Expiry Date",
          // label: "Ngày hết hạn",
        },
        {
          key: "donvicongtac",
          label: "Company",
          // label: "Đơn vị công tác",
          thStyle: { width: "250px !important" },
        },
        {
          key: "phongbancongtac",
          label: "Department",
          // label: "Phòng ban công tác",
          thStyle: { width: "250px !important" },
        },
        {
          key: "vitricongviec",
          label: "Position",
          // label: "Vị trí công việc",
        },
        {
          key: "loaihopdong",
          label: "Contract Type",
          // label: "Loại hợp đồng",
        },
        // {
        //   key: "hinhthuclamviec",
        //   label: "Hình thức làm việc",
        // },
        {
          key: "action",
          label: "",
          thStyle: { width: "75px !important" },
        },
      ],
      checkCommitment: false,
      disabledCommitment: false,
      item_null: {
        id: 0,
        employeeid: 0,
        sohopdong: null,
        nonResident: false,
        unemploymentInsurance: true,
        donvicongtac: null,
        phongbancongtac: null,
        vitricongviec: null,
        hinhthucnhanluong: null,
        loaihopdong: null,
        hinhthuclamviec: null,
        luongcoban: 0,
        luongdongbh: 0,
        luongthuviec: 0,
        ngayhieuluc: null,
        ngayhethan: null,
        commitment: false,
        status: 0,
      },
      item_selected: {
        id: 0,
        employeeid: 0,
        sohopdong: null,
        nonResident: false,
        unemploymentInsurance: true,
        donvicongtac: null,
        phongbancongtac: null,
        vitricongviec: null,
        hinhthucnhanluong: null,
        loaihopdong: null,
        hinhthuclamviec: null,
        luongcoban: 0,
        luongdongbh: 0,
        luongthuviec: 0,
        ngayhieuluc: null,
        ngayhethan: null,
        commitment: false,
        status: 0,
      },
      url: "/api/employeecontract/",
      modalShow: false,
      items: [],
      tempContractType: [],
      department_children: [],
      phongbancongtacEnabled: false,

      itemIdex: null,
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
    };
  },
  computed: {
    hoso_read() {
      return this.$store.getters.hasPermission("hoso_read");
    },
    hoso_create() {
      return this.$store.getters.hasPermission("hoso_create");
    },
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
    //Permissiong: Tab Phu cap/Thuong hoso_hdld_read hoso_hdld_cud
    hoso_hdld_read() {
      return this.$store.getters.hasPermission("hoso_hdld_read");
    },
    hoso_hdld_cud() {
      return this.$store.getters.hasPermission("hoso_hdld_cud");
    },
  },
  created() {
    if (this.item != null) this.initData();
  },
  methods: {
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    findFirstDepartmentByCode(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    },
    checkHieuLuc(ngayhethan) {
      var currentDay = new Date();
      currentDay = new Date(
        currentDay.getFullYear(),
        currentDay.getMonth(),
        currentDay.getDate(),
        0,
        0,
        0
      );

      ngayhethan = Date.parse(ngayhethan);
      //ngayhethan = this.$moment(ngayhethan);
      if (ngayhethan == null) return true;
      else if (ngayhethan < currentDay) {
        return false;
      }
      return true;
    },
    autoUpdateNgayHieuLuc() {
      this.$toast.error(this.item_selected.ngayhieuluc, "Error", {
        timeout: 3000,
      });
    },
    normalizer(node) {
      if (node.childs != null) {
        return {
          id: node.id,
          label: node.tendonvi,
          children: node.childs,
        };
      } else {
        return {
          id: node.id,
          label: node.tendonvi,
        };
      }
    },
    openModal(modalType) {
      this.$emit("openModal", modalType);
    },
    storeItem(bvModalEvt) {
      if (
        !this.item_selected.donvicongtac ||
        !this.item_selected.vitricongviec ||
        !this.item_selected.loaihopdong ||
        !this.item_selected.ngayhieuluc ||
        !(this.item_selected.sohopdong && this.item_selected.sohopdong.length)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin!", "Error", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (!this.item_selected.ngayhethan)
          this.item_selected.ngayhethan = null;
        if (this.item_selected.id <= 0) {
          this.item_selected.luongcoban = this.$refs.luong.item_selected.luongcoban;
          this.item_selected.luongdongbh = this.$refs.luong.item_selected.luongdongbh;
          this.item_selected.luongthuviec = this.$refs.luong.item_selected.luongthuviec;

          const payload = {
            hopdonglaodong: this.item_selected,
            luongs: this.$refs.luong.item_selected,
            phucaps: this.$refs.phucap.items,
            //hieuquas: this.$refs.hieuqua.items,
            thuongs: this.$refs.thuong.items,
            thuongpms: this.$refs.thuongpm.items,
          };

          payload.hopdonglaodong.ngayhieuluc = this.$convert_string_GMT7_DateTime(
            this.$convert_date_string(this.item_selected.ngayhieuluc)
          );

          payload.hopdonglaodong.ngayhethan = this.$convert_string_GMT7_DateTime(
            this.$convert_date_string(this.item_selected.ngayhethan)
          );

          axios
            .post(this.url, payload)
            .then((res) => {
              this.initData();
              // this.modalShow = false; //Khong dong khi LUU
              this.$toast.success("Update successfully", "Success", {
                timeout: 3000,
              });
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        } else {
          this.item_selected.luongcoban = this.$refs.luong.item_selected.luongcoban;
          this.item_selected.luongdongbh = this.$refs.luong.item_selected.luongdongbh;
          this.item_selected.luongthuviec = this.$refs.luong.item_selected.luongthuviec;

          const payload = {
            hopdonglaodong: this.item_selected,
            phucaps: this.$refs.phucap.items,
            luongs: this.$refs.luong.item_selected,
            //hieuquas: this.$refs.hieuqua.items,
            thuongs: this.$refs.thuong.items,
            thuongpms: this.$refs.thuongpm.items,
          };
          axios
            .put(this.url, payload)
            .then((res) => {
              this.initData();
              // this.modalShow = false; //Khong dong khi LUU
              this.$toast.success("Update successfully", "Success", {
                timeout: 3000,
              });
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        }
      }
    },
    stopItem() {
      axios
        .patch(this.url, this.item_selected)
        .then((res) => {
          this.modalShow = false;
          this.item_selected.status = 0;
          this.items[this.itemIdex] = JSON.parse(
            JSON.stringify(this.item_selected)
          );
          this.items = JSON.parse(JSON.stringify(this.items));
          this.itemIdex = null;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    formatPrice(value) {
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    initData() {
      axios
        .get(`${this.url + this.item.id}`)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    openItemModal() {
      this.item_selected = JSON.parse(JSON.stringify(this.item_null));
      this.item_selected.employeeid = this.item.id;
      this.modalShow = true;
      this.changeEmpType();
    },
    changeEmpType() {
      if (this.item_selected.hinhthuclamviec == "11") {
        this.tempContractType = this.loaihopdongs.slice(3, 8);
        this.checkCommitment = false;
        this.disabledCommitment = false;
      } else if (this.item_selected.hinhthuclamviec == "13") {
        this.tempContractType = this.loaihopdongs.slice(0, 3);
        this.checkCommitment = true;
        this.disabledCommitment = false;
      } else {
        this.checkCommitment = false;
        this.disabledCommitment = true;
        this.item_selected.loaihopdong = null;
      }
    },
    openUpdateItemModal(data) {
      this.item_selected = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;

      axios
        .get(`/api/department/parent/${data.item.donvicongtac}`)
        .then((res) => {
          this.department_children = res.data;
          this.item_selected.phongbancongtac = data.item.phongbancongtac;
          this.phongbancongtacEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data + "", "Error", { timeout: 3000 });
        });
      this.changeEmpType();
    },
    closeItemModal() {
      this.modalShow = false;
      this.lockPhongBan();
    },
    deleteItem(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`${this.url + data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successfully", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    unlockPhongban(department) {
      this.lockPhongBan();

      axios
        .get(`/api/department/parent/${this.item_selected.donvicongtac}`)
        .then((res) => {
          this.department_children = res.data;
          this.phongbancongtacEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data + "", "Error", { timeout: 3000 });
        });
    },

    lockPhongBan() {
      this.phongbancongtacEnabled = false;
      this.item_selected.phongbancongtac = null;
    },
  },
  watch: {
    "item_selected.ngayhieuluc": function(newValue, oldValue) {
      //9 = 1 nam, 8 = 3 nam, tang them so nam theo loai HD va tru di 1 ngay
      if (
        this.item_selected.loaihopdong == 9 &&
        this.item_selected.ngayhieuluc != null
      ) {
        var next1year = new Date(newValue);
        next1year.setDate(next1year.getDate() - 1); // tru di mot ngay
        next1year.setFullYear(next1year.getFullYear() + 1); // cong them 1 nam
        this.item_selected.ngayhethan = next1year;
      } else if (
        this.item_selected.loaihopdong == 8 &&
        this.item_selected.ngayhieuluc != null
      ) {
        var next3year = new Date(newValue);
        next3year.setDate(next3year.getDate() - 1);
        next3year.setFullYear(next3year.getFullYear() + 3);
        this.item_selected.ngayhethan = next3year;
      }
    },
    "item_selected.loaihopdong": function(newValue, oldValue) {
      if (newValue == 9 && this.item_selected.ngayhieuluc != null) {
        var next1year = new Date(this.item_selected.ngayhieuluc);
        next1year.setDate(next1year.getDate() - 1);
        next1year.setFullYear(next1year.getFullYear() + 1);
        this.item_selected.ngayhethan = next1year;
      } else if (newValue == 8 && this.item_selected.ngayhieuluc != null) {
        var next3year = new Date(this.item_selected.ngayhieuluc);
        next3year.setDate(next3year.getDate() - 1);
        next3year.setFullYear(next3year.getFullYear() + 1);
        this.item_selected.ngayhethan = next3year;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
